
import {UIGamePlayerInformationProgressCardController} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationProgressCardController'
import {UIMGamePlayerInformationProgressCardVictoryPointView} from './UIMGamePlayerInformationProgressCardVictoryPointView'
import {UIGamePlayerInformationView, UIPlayerAdditionalInformationLayer} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationView'
import {UIGamePlayerInformationProgressCardVictoryPointView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationProgressCardVictoryPointView'
import {GameColor} from '../../../../shared/scripts/GameColor'
import {UIGamePlayerInformationProgressCardView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationProgressCardView'

/**
 * @deprecated UIMGamePlayerInformationProgressCardController will be removed once Pixi.js Mobile Player Information view is removed.
 */
export class UIMGamePlayerInformationProgressCardController extends UIGamePlayerInformationProgressCardController {
    protected createProgressCardVictoryPointView(playerInformation: UIGamePlayerInformationView): UIGamePlayerInformationProgressCardVictoryPointView {
        return new UIMGamePlayerInformationProgressCardVictoryPointView(this.uiGameManager, playerInformation)
    }

    protected setProgressCardToolTip(playerInformation: UIGamePlayerInformationView) {
        super.setProgressCardToolTip(playerInformation)
        this.setProgressCardInformationToDropdown(playerInformation)
    }

    private setProgressCardInformationToDropdown(playerInformation: UIGamePlayerInformationView) {
        const container = playerInformation.getContainerForAdditionalPlayerInformation(UIPlayerAdditionalInformationLayer.Layer3)
        const devCards = playerInformation.developmentCardsPlayerState?.developmentCards.cards ?? []
        const viewX = 0
        const viewY = 0

        const viewW = container.width
        const viewH = container.height

        const textColor = GameColor.getColor(GameColor.Color.DarkGrey)
        new UIGamePlayerInformationProgressCardView(this.uiGameManager, viewX, viewY, viewW, viewH, container, devCards, false, textColor, playerInformation)
    }
}
